import { BadgeColor } from '@vendasta/galaxy/badge';

export const DefaultChipStyling = {
  selectedChipColor: 'blue' as BadgeColor,
  unselectedChipColor: 'grey' as BadgeColor,
};
